<div class="userSettingPages">
  <div class="headerDecs">
    <h2>{{ 'Support' | t }}</h2>
    <span>{{ 'inbox-desc' | t }}</span>
  </div>

  <div class="Txt-Inbox supportPage">
    <h2>{{ 'Support' | t }}</h2>
    <span>{{ 'inbox-desc' | t }}</span>
    <button mat-stroked-button class="wettButtons white" (click)="openDialog()">+ {{ 'New_Message' | t }}</button>
    <div class="supportPage" style="margin-top: 25px">
      <mat-card class="example-card" *ngFor="let item of this._DataHelper.DataCustomerTicketList" style="margin-bottom: 8px">
        <div style="width: 100%; margin-bottom: 6px; height: 14px">
          <div style="width: 60%; float: left; font-weight: bold">
            <span class="inbox-statu-span" style="margin-right: 5px" [ngClass]="{ 'inbox-statu-open': item.StatusId == 1, 'inbox-statu-close': item.StatusId == 2 }">
              {{ item.Statu }}
            </span>
            <span style="font-size: 14px">{{ item.Subject }}</span>
          </div>
          <div style="width: 40%; float: left; text-align: right; font-size: 12px">{{ item.CreateDateISO | dateFormatDistance }}</div>
        </div>
        <mat-card-content style="margin-bottom: 0px">
          <p>
            {{ item.Description }}
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button
            mat-flat-button
            class="inbox-messages-button"
            color="primary"
            style="width: 100%; color: white; font-weight: bold"
            (click)="getCustomerTicketDetail(item.TicketId, item.Subject)">
            {{ 'Show_Messages' | t }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <mat-card class="attention-card" *ngIf="this._DataHelper.DataCustomerTicketList?.length == 0">{{ 'Support_Length_Zero' | t }}</mat-card>
  </div>
</div>
